import { render } from "./sales-card.vue?vue&type=template&id=55cc794a&scoped=true"
import script from "./sales-card.vue?vue&type=script&lang=ts"
export * from "./sales-card.vue?vue&type=script&lang=ts"

import "./sales-card.vue?vue&type=style&index=0&id=55cc794a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-55cc794a"

export default script